import { useMemo } from 'react'

import { LocalStorageKeys, useLocalStorage } from '@/lib/storage/local-storage.hook'

import { MAX_FREQUENTLY_USED_EMOJIS } from '@/components/lemmala-design-system/emoji-picker/consts'

export const useFrequentlyUsedEmojis = () => {
  const [counts, setCounts] = useLocalStorage(LocalStorageKeys.emojiUseCounts)

  const emojis = useMemo(
    () =>
      Object.entries(counts ?? {})
        .sort(([, a], [, b]) => b - a)
        .slice(0, MAX_FREQUENTLY_USED_EMOJIS)
        .map(([emoji]) => emoji),
    [counts],
  )

  const record = (emoji: string) => {
    setCounts({ ...counts, [emoji]: (counts?.[emoji] ?? 0) + 1 })
  }

  return { emojis, record }
}
